import publicAPI from '../../api/public';

export default {
  namespaced: true,

  state: {
    globalConfig: {},
    content: {},
    images: {},
    loading: false,
    error: null,
    footerCache: {
      data: null,
      timestamp: null,
      ttl: 60 * 60 * 1000,
    },
  },

  mutations: {
    SET_LOADING(state, loading) {
      state.loading = loading;
    },

    SET_ERROR(state, error) {
      state.error = error;
    },

    SET_DATA(state, { globalConfig, content, images }) {
      state.globalConfig = globalConfig;
      state.content = content;
      state.images = images;
      
      // Cache footer data
      if (content.footer) {
        state.footerCache.data = content.footer;
        state.footerCache.timestamp = Date.now();
      }
    },
    
    SET_FOOTER_CACHE(state, footerData) {
      state.footerCache.data = footerData;
      state.footerCache.timestamp = Date.now();
    },
  },

  actions: {
    async fetchContent({ commit, rootGetters, state }) {
      commit('SET_LOADING', true);
      commit('SET_ERROR', null);

      try {
        const locale = rootGetters['locale/current'];
        const data = await publicAPI.fetchLandingContent(locale);
        commit('SET_DATA', {
          globalConfig: data.global_config,
          content: data.content,
          images: data.images,
        });
      } catch (error) {
        commit('SET_ERROR', error.message);
        console.error('Failed to fetch landing content:', error);
      } finally {
        commit('SET_LOADING', false);
      }
    },
    
    async fetchContentWithCache({ commit, rootGetters, state }) {
      // Check if we have valid cached footer data
      const now = Date.now();
      const isCacheValid = state.footerCache.data && 
                          state.footerCache.timestamp && 
                          (now - state.footerCache.timestamp) < state.footerCache.ttl;
      
      if (isCacheValid) {
        // Use cached data, only fetch if content is empty
        if (!state.content || Object.keys(state.content).length === 0) {
          await this.dispatch('home/fetchContent');
        }
        return;
      }
      
      // Cache expired or no data, fetch fresh content
      await this.dispatch('home/fetchContent');
    },
  },

  getters: {
    globalConfig: state => state.globalConfig,
    content: state => state.content,
    images: state => state.images,
    loading: state => state.loading,
    error: state => state.error,
    footerData: state => {
      // Return cached footer data if available, otherwise return from content
      return state.footerCache.data || state.content?.footer || {};
    },
  },
};

